import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';

import ForgotPassword from 'pages/ForgotPassword/ForgotPassword';
import LandingPage from 'pages/LandingPage/LandingPage';
import LicensePortalPage from 'pages/LicencePortal/LicensePortalPage';
import NewLogin from 'pages/NewLogin/NewLogin';
import ResetOrSetPassword from 'pages/ResetOrSetPassword/ResetOrSetPassword';
import SyncingUsersAndFinishingPage from 'pages/SyncingUsersAndFinishing/SyncingUsersAndFinishing';
import Welcome from 'pages/Welcome/Welcome';
import Dashboard from '../Dashboard/Dashboard';

export interface Props {
  isLoading: boolean;
  isUserAuthenticated: boolean;
}

const Router: React.FC<React.PropsWithChildren<Props>> = ({ isLoading, isUserAuthenticated }) => (
  <BrowserRouter>
    {isLoading ? (
      <Welcome />
    ) : (
      <Routes>
        <Route path="/connect-to-atlas" element={<LicensePortalPage />} />
        <Route path="/synchronize-with-entra" element={<SyncingUsersAndFinishingPage />} />
        <Route path="/set-password" element={<ResetOrSetPassword pageVariant="SET" />} />
        <Route path="/landing/access" element={<LandingPage type="access" />} />
        <Route path="/landing/config" element={<LandingPage type="config" />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetOrSetPassword pageVariant="RESET" />} />
        <Route path="*" element={isUserAuthenticated ? <Dashboard /> : <NewLogin />} />
      </Routes>
    )}
  </BrowserRouter>
);

export default Router;
